import { currencyFormatter } from "@/utils/currencyFormatter";
import { Slider, SliderInputControl } from "@repo/skapa";
import { getLanguageLocal } from "@repo/translation";
import { useDebouncedEffect, useSettings } from "@repo/ui";
import { useState } from "react";

interface PriceSliderProps {
  id: string;
  minAmount: number;
  maxAmount: number;
  currency: string;
  value: number[];
  onChange: (value: number[]) => void;
}

export const PriceSlider = ({
  id,
  minAmount,
  maxAmount,
  currency,
  value,
  onChange,
}: PriceSliderProps) => {
  const { market, language, general } = useSettings();
  const locale = getLanguageLocal(language, market);

  const [sliderValue, setSliderValue] = useState(value);

  useDebouncedEffect(
    () => {
      if (sliderValue !== undefined && sliderValue !== value) {
        onChange(sliderValue);
      }
    },
    500,
    [sliderValue]
  );

  return (
    <Slider
      id={id}
      label=""
      ariaLabels={["From", "To"]}
      range={{
        min: minAmount,
        max: maxAmount,
      }}
      prefixLabel={currency}
      inputControls={<SliderInputControl type="text" />}
      start={sliderValue}
      onChange={setSliderValue}
      step={100}
      margin={100}
      ariaFormat={{
        to: (val) =>
          currencyFormatter({
            value: val,
            currency,
            locale,
            showSign: true,
            disableDecimals: Boolean(general?.localization?.disable_decimals),
            fractions: 0,
          }),
        from: (val) => Number(val),
      }}
    />
  );
};
